<h2 mat-dialog-title>Idle Robot Escalations ({{ idleMinutes }}+ min)</h2>

<mat-dialog-content>
  <div class="dialog-controls">
    <mat-checkbox [checked]="autoPopupDisabled" (change)="onAutoPopupChanged($event)">
      Disable automatic popups
    </mat-checkbox>
  </div>

  @if (idleEscalations.length) {
    <div class="idle-escalation-table-wrapper">
      <table class="idle-escalation-table">
        <thead>
        <tr>
          <th>Robot</th>
          <th>Alerts</th>
          <th>Priority</th>
          <th>Idle</th>
          <th>Assignee</th>
          <th>Snooze</th>
        </tr>
        </thead>
        <tbody>
          @for (item of idleEscalations; track item.id) {
            <tr [class.new-row]="item.isNew">
              <td>
                <div class="robot-cell">
                  @if (item.isNew) {
                    <span class="new-chip">NEW</span>
                  }
                  <span class="robot-name">{{ item.robotName }}</span>
                </div>
              </td>
              <td>{{ item.eventsCount || 0 }}</td>
              <td>{{ item.priority }}</td>
              <td>{{ idleDuration(item) }}</td>
              <td>
                <div class="action-cell">
                   <mat-form-field appearance="outline" subscriptSizing="dynamic">
                     <mat-label>Reassign</mat-label>
                     <mat-select
                       [(ngModel)]="selectedAssigneeByEscalationId[item.id]"
                       (selectionChange)="onReassignSelectionChanged(item, $event.value)"
                       [disabled]="isUpdating(item.id)">
                       <mat-option [value]="null">Unassigned</mat-option>
                       @for (user of skyboxUsers; track user.id) {
                         <mat-option [value]="user.id">{{ user.email }}</mat-option>
                       }
                     </mat-select>
                   </mat-form-field>
                </div>
              </td>
              <td>
                <div class="action-cell snooze-links">
                  <a class="clickable snooze-link" (click)="snooze(item, 30)" [class.disabled]="isUpdating(item.id)">30</a>
                  <span class="snooze-separator">|</span>
                  <a class="clickable snooze-link" (click)="snooze(item, 60)" [class.disabled]="isUpdating(item.id)">60</a>
                  <span class="snooze-separator">|</span>
                  <a class="clickable snooze-link" (click)="snooze(item, 120)" [class.disabled]="isUpdating(item.id)">120</a>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  } @else {
    <div class="empty-state">No idle escalations right now.</div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button [matDialogClose]="">Close</button>
</mat-dialog-actions>


